import { gql } from '@apollo/client';
import { rewardFragment } from '../fragments/reward';

export const getRewardsQuery = gql`
    ${rewardFragment}

    query GetRewards {
        rewards {
            ...RewardFields
        }
        user {
            id
            collectedCurrency
        }
    }
`;